'use strict';

var store = require('adyen_config/store');
var constants = require('adyen_config/constants');
var AMAZON_PAY = constants.AMAZON_PAY;
var initCheckout = require('../../initializeCheckout');
var initializeCheckout = initCheckout.initializeCheckout;

function AmazonPay(config, applicationInfo, adyenTranslations) {
    var returnUrl = window.returnUrl;
    this.store = store;
    this.showPayButton = true;
    this.isExpress = true;
    this.returnUrl = returnUrl;
    this.applicationInfo = applicationInfo;
    this.translations = adyenTranslations;
    this.config = config;
}

AmazonPay.prototype.getConfig = function () {
    return {
        configuration: this.config,
        showPayButton: this.showPayButton,
        isExpress: this.isExpress,
        returnUrl: this.returnUrl,
        productType: 'PayAndShip'
    };
};

AmazonPay.prototype.getComponent = function () {
    var self = this;
    return initializeCheckout(
        this.applicationInfo,
        this.translations
    ).then(function (checkout) {
        var amazonPayConfig = self.getConfig();
        return window.AdyenWeb.createComponent(
            AMAZON_PAY,
            checkout,
            amazonPayConfig
        );
    });
};

module.exports = AmazonPay;
